import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthProvider from "./components/AuthProvider";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Header from "./pages/Header";
import Footer from "./pages/Footer";
import LoginModal from "./pages/LoginModal";
import RegisterModal from "./pages/PartnerRegistration";
import CustomerLogin from "./pages/CustomerLogin";
import CustomerDashboardLayout from "./pages/CustomerDashboard/CustomerDashboardLayout";
import CustomerOverview from "./pages/CustomerDashboard/Overview";
import CustomerProperties from "./pages/CustomerDashboard/Properties";
import CustomerPayments from "./pages/CustomerDashboard/Payments";
import CustomerProfile from "./pages/CustomerDashboard/Profile";
import ProtectedRoute from "./components/ProtectedRoute";
import OurPlan from "./pages/OurPlan";
import LegalPage from "./pages/LegalPage";
import OurGallery from "./pages/OurGallery";
import PlotAvailability from "./pages/PlotAvailability";
// import CustomerRegistration from "./pages/CustomerRegistration";
import RegistrationPage from "./pages/RegistrationPage";
import DashboardLayout from "./pages/DashboardLayout";
import Overview from "./pages/Overview";
import ShowProfile from "./pages/ShowProfile";
import UpdateProfile from "./pages/UpdateProfile";
import UpdateLoginPassword from "./pages/UpdateLoginPassword";
import UpdateKYC from "./pages/UpdateKYC";
import BusinessPlanChart from "./pages/BusinessPlanChart";
import BuyPackage from "./pages/BuyPackage";
import ListInvoices from "./pages/ListInvoices";
import InvoicePage from "./pages/InvoicePage";
import AddTeamMember from "./components/admin/AddTeamMember";
import TeamMemberList from "./components/admin/TeamMemberList";
import PaymentHistoryTable from "./components/admin/PaymentHistoryTable";
import AddPlan from "./components/admin/AddPlan";
import PlanList from "./components/admin/PlanList";
import AddLegal from "./components/admin/AddLegal";
import ListLegal from "./components/admin/ListLegal";
import AddNews from "./components/admin/AddNews";
import ListNews from "./components/admin/ListNews";
import AdminLayout from "./components/admin/AdminLayout";
import { useSelector, useDispatch } from "react-redux";
import { getValue, setValue } from "./features/UserInfo/userSlice";
import { sendApiRequest } from "./utils";
import MyDirectNetwork from "./pages/MyDirectNetwork";
import MyTotalNetwork from "./pages/MyTotalNetwork";
import MonthlyIncome from "./pages/MonthlyIncome";
import NetworkExplorer from "./pages/NetworkExplorer";
import AddGallery from "./components/admin/AddGallery";
import ListGallery from "./components/admin/ListGallery";
import BusinessIncentiveIncome from "./pages/BusinessIncentiveIncome";
import BDIIncome from "./pages/BDIIncome";
import WithdrawalRequestList from "./pages/WithDrawalRequestList";
import WithdrawalRequestForm from "./pages/WithdrawalRequestForm";
import MainWalletTransaction from "./pages/MainWalletTransaction";
import AddPlot from "./components/admin/AddPlot";
import ListPlot from "./components/admin/ListPlot";
import ContactList from "./components/admin/ContactList";
import AdminOverview from "./components/admin/AdminOverview";
import AddNewPackage from "./components/admin/AddNewPackage";
import AllCustomers from "./components/admin/AllCustomers";
import AllPartner from "./components/admin/AllPartner";
import AdminNetworkExplorer from "./components/admin/AdminNetworkExplorer";
import MyAllPackageRequests from "./pages/MyAllPackageRequests";
import ShowAllPackageApproval from "./components/admin/ShowAllPackageApproval";
import GeneratePackageReceipt from "./components/admin/GeneratePackageReceipt";
import ViewPackageReceipt from "./components/admin/ViewPackageReceipt";
import MyReceipts from './pages/MyReceipts';
import GenerateManuallyReceipt from "./components/admin/GenerateManuallyReceipt";
import KYCApprovalRequest from "./components/admin/KYCApprovalRequest";
import ClosingReport from "./components/admin/ClosingReport";
import WithdrawalRequests from './components/admin/WithdrawalRequests';
import ShowAllPackages from "./components/admin/ShowAllPackages";
import MonthWiseExcelReport from "./components/admin/MonthWiseExcelReport";
import AddNewReward from "./components/admin/AddNewReward";
import ShowAllRewards from "./components/admin/ShowAllRewards";
import Rewards from "./pages/Rewards";
import MyRewards from "./pages/MyRewards";
import HostingerExpiryModal from "./components/HostingerExpiryModal";

function App() {
  const dispatch = useDispatch();
  const user = useSelector(getValue);
  const userData = user.payload?.user_info?.[0];
  const [isRefresh, setIsRefresh] = useState("yes");

  const getUserInfo = async () => {
    try {
      const response = await sendApiRequest("api/auth/verify-token", {}, "GET");
      if (response.data.success) {
        dispatch(setValue(response.data));
      }
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  useEffect(() => {
    getUserInfo();
  }, [isRefresh]);

  return (
    <Router>
      <AuthProvider>
        <AppContent isRefresh={isRefresh} setIsRefresh={setIsRefresh} />
      </AuthProvider>
    </Router>
  );
}

function AppContent({ isRefresh, setIsRefresh }) {
  const [showBackToTop, setShowBackToTop] = useState(false);
  const location = useLocation();
  const isDashboardRoute =
    location.pathname.startsWith("/dashboard") ||
    location.pathname.startsWith("/print-invoice") ||
    location.pathname.startsWith("/customer") ||
    location.pathname.startsWith("/admin");

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowBackToTop(true);
      } else {
        setShowBackToTop(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="font-['Montserrat']">
  {/* <HostingerExpiryModal/> */}
      {!isDashboardRoute && (
        <Header isRefresh={isRefresh} setIsRefresh={setIsRefresh} />
      )}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route
          path="/login-customer"
          element={
            <CustomerLogin isRefresh={isRefresh} setIsRefresh={setIsRefresh} />
          }
        />
        <Route
          path="/customer"
          element={
            <ProtectedRoute>
              <CustomerDashboardLayout
                isRefresh={isRefresh}
                setIsRefresh={setIsRefresh}
              />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<CustomerOverview />} />
          <Route path="properties" element={<CustomerProperties />} />
          <Route path="payments" element={<CustomerPayments />} />
          <Route path="profile" element={<CustomerProfile />} />
        </Route>
        <Route path="/register" element={<RegistrationPage />} />
        <Route
          path="/login"
          element={
            <LoginModal isRefresh={isRefresh} setIsRefresh={setIsRefresh} />
          }
        />
        <Route path="/plan" element={<OurPlan />} />
        <Route path="/legal" element={<LegalPage />} />
        <Route
          path="/dashboard"
          element={
            <DashboardLayout
              isRefresh={isRefresh}
              setIsRefresh={setIsRefresh}
            />
          }
        >
          <Route index element={<Overview />} />
          <Route path="show-profile" element={<ShowProfile />} />
          <Route path="update-profile" element={<UpdateProfile />} />
          <Route
            path="update-login-password"
            element={<UpdateLoginPassword />}
          />
          <Route path="update-kyc" element={<UpdateKYC />} />
          <Route path="show-business-plan" element={<BusinessPlanChart />} />
          <Route path="buy-package" element={<BuyPackage />} />
          <Route path="my-packages" element={<MyAllPackageRequests />} />
          <Route path="list-invoices" element={<ListInvoices />} />
          <Route path="my-direct-network" element={<MyDirectNetwork />} />
          <Route path="my-total-network" element={<MyTotalNetwork />} />
          <Route path="monthly-income" element={<MonthlyIncome />} />
          <Route path="network-explorer" element={<NetworkExplorer />} />
          <Route path="packages/view-receipt" element={<ViewPackageReceipt />} />
          <Route
            path="incentive-income"
            element={<BusinessIncentiveIncome />}
          />
          <Route path="bdi-income" element={<BDIIncome />} />
          <Route path="withdrawal-status" element={<WithdrawalRequestList />} />
          <Route
            path="withdrawal-request"
            element={<WithdrawalRequestForm />}
          />
          <Route
            path="wallet-transactions"
            element={<MainWalletTransaction />}
          />
          <Route path="my-receipts" element={<MyReceipts />} />
            <Route path="my-rewards" element={<MyRewards />} />
            {/* Add other dashboard routes here */}
            {/* <Route path="team-member/add" element={<AddTeamMember />} />
            <Route path="team-member/list" element={<TeamMemberList />} /> */}

            {/* Add other dashboard routes here */}
            {/* <Route path="plan/add" element={<AddPlan />} />
            <Route path="plan/list" element={<PlanList />} /> */}
        </Route>

        {/* ADMIN LAYOUT */}
        <Route path="/admin" element={<AdminLayout setIsRefresh={setIsRefresh}/>}>
          <Route index element={<AdminOverview />} />
          {/* Add other dashboard routes here */}
          <Route path="team-member/add" element={<AddTeamMember />} />
          <Route path="team-member/list" element={<TeamMemberList />} />

          {/* Add other dashboard routes here */}
          <Route path="plan/add" element={<AddPlan />} />
          <Route path="plan/list" element={<PlanList />} />
          {/* Add Legal */}
          <Route path="legal/add" element={<AddLegal />} />
          <Route path="legal/list" element={<ListLegal />} />
          {/* Add Gallery */}
          <Route path="gallery/add" element={<AddGallery />} />
          <Route path="gallery/list" element={<ListGallery />} />
          <Route path="payment/history" element={<PaymentHistoryTable />} />
          {/* Add News */}
          <Route path="news/add" element={<AddNews />} />
          <Route path="news/list" element={<ListNews />} />
          {/*Add Plat  */}
          <Route path="plot/add" element={<AddPlot />} />
          <Route path="plot/list" element={<ListPlot />} />
          {/* Contact List */}
          <Route path="contact/list" element={<ContactList />} />
          {/* Add Packages */}
          <Route path="packages/add" element={<AddNewPackage />} />
          <Route path="packages/show" element={<ShowAllPackages />} />
          <Route path="packages/approval" element={<ShowAllPackageApproval />} />
          <Route path="packages/generate-receipt" element={<GeneratePackageReceipt />} />
          <Route path="packages/generate-receipt-manually" element={<GenerateManuallyReceipt />} />
          <Route path="packages/view-receipt" element={<ViewPackageReceipt />} />
          <Route path="packages/month-wise-excel-report" element={<MonthWiseExcelReport />} />
          <Route path="customer/list" element={<AllCustomers />} />
          <Route path="partner/list" element={<AllPartner />} />
          <Route path="admin-network-explorer" element={<AdminNetworkExplorer />} />
          <Route path="kyc-approval/list" element={<KYCApprovalRequest />} />
          <Route path="closing-reports" element={<ClosingReport />} />
          <Route path="withdrawal-requests" element={<WithdrawalRequests />} />
          <Route path="rewards/add" element={<AddNewReward />} />
          <Route path="rewards/list" element={<ShowAllRewards />} />
          {/* <Route path="packages/list" element={<ListPackage />} /> */}
        </Route>
        {/* ADMIN END */}

        <Route path="/print-invoice" element={<InvoicePage />} />
        <Route path="/gallery" element={<OurGallery />} />
        <Route path="/plot-availability" element={<PlotAvailability />} />
        <Route path="/rewards" element={<Rewards />} />
      </Routes>
      {!isDashboardRoute && <Footer />}
      {showBackToTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-8 right-8 bg-[#2AADCC] text-white p-4 rounded-full shadow-lg hover:bg-[#30AEB8] transition-colors z-50"
          title="Back to Top"
        >
          ↑
        </button>
      )}
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
    </div>
  );
}

export default App;
